import { FC, useCallback } from 'react';
import { StyledPrimaryButton } from '../../styled';
import { firstLetterUppercase } from '../../utils';

export interface PrimaryButtonProps {
  text: string;
  href?: string;
  onClose: () => void;
}

export const PrimaryButton: FC<PrimaryButtonProps> = ({
  text,
  href,
  onClose,
}) => {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (href && href !== '') {
        e.preventDefault();
        window.location.href = href;
      }
      onClose();
    },
    [href, onClose],
  );

  if (href && href !== '') {
    const anchorAttrs: Pick<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      'target' | 'rel'
    > = { target: '_self', rel: 'noopener noreferrer' };
    return (
      <StyledPrimaryButton
        component="a"
        href={href}
        variant="outlined"
        onClick={handleClick}
        {...anchorAttrs}
      >
        {firstLetterUppercase(text)}
      </StyledPrimaryButton>
    );
  }

  return (
    <StyledPrimaryButton variant="outlined" onClick={handleClick}>
      {firstLetterUppercase(text)}
    </StyledPrimaryButton>
  );
};
